// @mui
import { Box, Dialog, DialogProps, Paper } from "@mui/material";
import { AnimatePresence, m } from "framer-motion";

//
import { varFade } from "./variants";

// ----------------------------------------------------------------------

export interface Props extends DialogProps {
	variants?: Record<string, unknown>;
	onClose?: VoidFunction;
	disableBackdropClick?: boolean;
}

export default function DialogAnimate({
	open = false,
	variants,
	onClose,
	children,
	maxWidth = "xs",
	disableBackdropClick,
	sx,
	...other
}: Props) {
	return (
		<AnimatePresence>
			{open && (
				<Dialog
					PaperComponent={(props) => (
						<Box
							component={m.div}
							{...(variants ||
								varFade({
									distance: 120,
									durationIn: 0.32,
									durationOut: 0.24,
									easeIn: "easeInOut"
								}).inUp)}
							sx={{
								width: "100%",
								height: "100%",
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}}
						>
							<Box
								onClick={!disableBackdropClick ? onClose : undefined}
								sx={{ width: "100%", height: "100%", position: "fixed" }}
							/>
							<Paper sx={sx} {...props}>
								{props.children}
							</Paper>
						</Box>
					)}
					fullWidth
					maxWidth={maxWidth}
					onClose={onClose}
					open={open}
					{...other}
				>
					{children}
				</Dialog>
			)}
		</AnimatePresence>
	);
}
